<template>
  <div
    class="lollipop-selector"
    :class="{
      open: open,
      disabled: disabled,
      'is-loading': isLoading
    }"
  >
    <dropdown-select
      v-model="ownSelection"
      :multiple="true"
      :options="availableOptions"
      :disabled="disabled || isLoading"
      :label-parser="literal"
      :size="5"
      :close-on-select="true"
      @open="open = true"
      @close="open = false"
    >
      <div v-if="dimensions.length > 1" class="lollipop-selector__dimension-select">
        <div
          v-for="(dimension, i) in dimensions"
          :key="i"
          class="lollipop-selector__dimension"
          :class="{ active: dimension.id === currentDimension.id }"
          @click="setCurrentDimension(dimension)"
        >
          {{ $lng(dimension.name[lng], dimension.id) }}
        </div>
      </div>
    </dropdown-select>
  </div>
</template>

<script>
import DropdownSelect from './DropdownSelect.vue'

export default {
  components: { DropdownSelect },
  props: ['selection', 'currentDimension', 'dimensions', 'constraints', 'disabled', 'isLoading'],
  data() {
    return {
      open: false,
    }
  },
  computed: {
    ownSelection: {
      get() {
        return this.selection || []
      },
      set(v) {
        this.$emit('update', v)
      },
    },
    breakdownSelection() {
      return this.$store.state.query.mainBreakdowns
    },
    options() {
      const selectedBreakdownId =
        this.breakdownSelection[this.currentDimension.id] ||
        (this.currentDimension.hasGroups
          ? this.currentDimension.options[0].children[0].id
          : this.currentDimension.options[0].id)

      function clone(d) {
        return {
          id: d.id,
          parentCode: d.parentCode,
          labels: d.labels,
          isValid: d.id !== selectedBreakdownId,
          children:
            d.children && Array.isArray(d.children)
              ? d.children.filter(c => c.id !== selectedBreakdownId).map(c => clone(c))
              : [],
        }
      }
      return this.currentDimension.options.map(clone)
    },
    availableOptions() {
      const currentConstraints = this.constraints.find(c => c.id === this.currentDimension.id)
      if (!currentConstraints) return this.options

      const availableValues = Object.fromEntries(currentConstraints.values.map(v => [v, true]))
      const filterOptions = (options) => {
        return options.filter(opt => {
          if (opt.children) {
            opt.children = filterOptions(opt.children)
          }

          return availableValues[opt.id]
        })
      }

      return filterOptions(this.options)
    }
  },
  methods: {
    setCurrentDimension(dimension) {
      this.$emit('switch-dimension', dimension)
    },
    literal() {
      const dimName = this.$lng(this.currentDimension.name[this.lng], this.currentDimension.id)
      return `<label>Context:</label>
      <span class="value">${dimName} (${this.ownSelection.length})</span>`
    },
  },
}
</script>

<style lang="stylus">
.lollipop-selector
  cursor: pointer
  flex: 1 1 0%
  position: relative

  +m-breakpoint(sm md)
    max-width: 90vw

  &.disabled:not(.is-wrapped)
    cursor: default
    max-width: 90vw

  &.open
    .dropdown-select__label
      border-bottom: none

  &.is-loading::after
    position: absolute
    top: 0
    left: 0
    width: 100%
    height: 100%
    cursor: progress
    z-index: 10
    background-color: transparent
    content: ""

  .dropdown-select__label
    align-items: center
    display: flex
    border-bottom: 1px solid $gray

    > label
      margin-right: 0.5em
      font-size: 0.85em
      line-height: 1.25

      +m-breakpoint(md)
        .mobile &
          font-size: 0.8em

    > .value
      m-font-size(12, 20)
      m-ellipsis(100%)
      margin-right: 0.5em
      margin-top: 0.15em
      font-size: 0.85em
      line-height: 1.75

      +m-breakpoint(md)
        .mobile &
          font-size: 0.8em

.lollipop-selector__dimension-select
  background-color: white
  display: flex
  font-size: 0.8em
  padding: 0.4em .5em
  justify-content: flex-start

  .mobile &
    padding-right: calc(.5em + 5px)

.lollipop-selector__dimension
  border: 1px solid $gray
  padding: 0.5em 1em
  font-size: .8em
  text-align: center

  &:first-child
    border-bottom-left-radius: 5px
    border-top-left-radius: 5px

    &.active
      margin-left: .5em

  &:last-child
    border-bottom-right-radius: 5px
    border-top-right-radius: 5px

    &.active
      margin-right: .5em

  &.active
    background-color: #edf3fc
    border-left: unset
    border-radius: 0
    border-right: unset
    color: $blue-2
    padding: .5em
    position: relative

    &:before,
    &:after
      background-color: white
      background-color: #edf3fc
      content: ""
      height: 100%
      position: absolute
      top: 0
      width: .5em
      z-index: 10

    &:before
      border-bottom-left-radius: 5px
      border-left: 1px solid $gray
      border-top-left-radius: 5px
      left: -0.5em

    &:after
      border-bottom-right-radius: 5px
      border-right: 1px solid $gray
      border-top-right-radius: 5px
      right: -0.5em
</style>
